import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import '../../../Buttons/IconButton/index.js';
import { useHeaderActionButton } from './hooks/useHeaderActionButton.js';
import { IconButton } from '../../../Buttons/IconButton/IconButton.js';

var HeaderActionButtonComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useHeaderActionButto = useHeaderActionButton(props),
    actionButtonProps = _useHeaderActionButto.actionButtonProps;
  return /*#__PURE__*/React.createElement(IconButton, _extends({}, actionButtonProps, {
    ref: ref
  }));
});
var HeaderActionButton = /*#__PURE__*/React.memo(HeaderActionButtonComponent);
HeaderActionButtonComponent.displayName = 'Header.ActionButton';

export { HeaderActionButton, HeaderActionButtonComponent };
//# sourceMappingURL=HeaderActionButton.js.map
